import type { ComputedRef } from 'vue'
import type { AttributeConfig } from 'v-calendar/dist/types/src/utils/attribute.d.ts'
import type { CalendarDay } from 'v-calendar/dist/types/src/utils/page.d.ts'
import type { CalendarTooltip } from '@shared/ui/calendars'

import { useBookingStore } from '@entities/booking'
import { getLessonTooltips } from '@entities/booking'
import { useDisciplineStore } from '@entities/customer'
import { formatDefaultDate } from '@shared/lib/format'

interface CalendarLessonsReturn {
  lessonDots: ComputedRef<AttributeConfig[]>
  getDayTooltip: (day: CalendarDay) => CalendarTooltip | undefined
}

export const useCalendarLessons = (): CalendarLessonsReturn => {
  const bookingStore = useBookingStore()
  const disciplineStore = useDisciplineStore()

  const lessons = computed(() => bookingStore.getBookings || [])

  const lessonDots = computed<AttributeConfig[]>(() => lessons.value.map(lesson => ({
    key: `lesson-${lesson.id}`,
    dot: { class: 'lcv-dot' },
    dates: [formatDefaultDate(lesson.start)],
  })))

  const tooltips = computed(() => getLessonTooltips(lessons.value, disciplineStore.getDisciplineCodeLabel))

  const getDayTooltip = (day: CalendarDay): CalendarTooltip | undefined => tooltips.value.find(tooltip => tooltip.date === day.id)

  return {
    lessonDots,
    getDayTooltip,
  }
}
